export const FETCH_COURSE_LIST = 'FETCH_COURSE_LIST';
export const UPDATE_SEARCH_TERM = 'UPDATE_SEARCH_TERM';
export const FETCH_COURSE_DETAILS = 'FETCH_COURSE_DETAILS';
